<template>
  <section class="section">
    <div class="container">
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <b-field>
            <b-input
              v-model="queryString"
              :placeholder="$translate('search').concat('...') | capitalize"
              type="search"
              icon="magnify"
              @keyup.native.enter="searchData()"
            ></b-input>
          </b-field>
        </div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        default-sort="user.first_name"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        checkable
        :checked-rows.sync="checkedRows"
        :is-row-checkable="row => !permissionDenied"
        @check="checkModel($event)"
      >
        <template slot-scope="props">
          <b-table-column field="name" :label="$translate('model') | capitalize" sortable>{{
            props.row.name
          }}</b-table-column>
          <b-table-column
            field="modelImage"
            :label="$translate('image') | capitalize"
            :width="module === 'insole' ? '90px' : null"
          >
            <img :src="props.row.image" :width="module === 'insole' ? '70px' : '100px'" height="auto" />
          </b-table-column>

          <template v-if="$moduleConfiguration[module].minPel === $moduleConfiguration[module].maxPel">
            <b-table-column
              v-for="i in $moduleConfiguration[module].maxPel"
              :key="`pell${i}var`"
              :field="`pell${i}var`"
              :label="$translate(`pell${i}title`) | capitalize"
            >
              <b-tooltip :label="props.row[`pell${i}tag`]" position="is-left">
                <img :src="props.row[`pellImage${i}`]" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
          </template>
          <template v-else>
            <b-table-column width="200px" field="pellami" :label="$translate(`pellami`) | capitalize">
              <div class="pellami-container">
                <b-tooltip
                  v-for="i in props.row.pelCount"
                  :key="`pell${i}var`"
                  :label="props.row[`pell${i}tag`]"
                  position="is-left"
                >
                  <img
                    :src="props.row[`pellImage${i}`]"
                    width="50px"
                    height="auto"
                    @click="() => showImageModal(props.row[`pellImage${i}`], props.row[`pell${i}tag`])"
                  />
                </b-tooltip>
              </div>
            </b-table-column>
            <b-table-column
              v-if="$moduleConfiguration[module].modelHasRiporti"
              width="200px"
              field="riporti"
              :label="$translate(`riporti`) | capitalize"
            >
              <div class="pellami-container">
                <b-tooltip
                  v-for="i in props.row.ripCount"
                  :key="`rip${i}var`"
                  :label="props.row[`rip${i}tag`]"
                  position="is-left"
                >
                  <img
                    :src="props.row[`ripImage${i}`]"
                    width="50px"
                    height="auto"
                    @click="() => showImageModal(props.row[`ripImage${i}`], props.row[`rip${i}tag`])"
                  />
                </b-tooltip>
              </div>
            </b-table-column>
          </template>
          <template v-if="module === 'tailored'">
            <b-table-column field="fodantvar" :label="$translate('fodanttitle') | capitalize">
              <b-tooltip :label="props.row.fod1tag" position="is-left">
                <img :src="props.row.fodImage1" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
            <b-table-column field="fodposvar" :label="$translate('fodpostitle') | capitalize">
              <b-tooltip :label="props.row.fod2tag" position="is-left">
                <img :src="props.row.fodImage2" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
            <b-table-column field="battvar" :label="$translate('batttitle') | capitalize">
              <b-tooltip :label="props.row.battag" position="is-left">
                <img :src="props.row.batImage" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
            <b-table-column field="intevar" :label="$translate('intetitle') | capitalize">
              <b-tooltip :label="props.row.inttag" position="is-left">
                <img :src="props.row.intImage" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
          </template>
          <template v-if="module === 'insole'">
            <b-table-column width="160px" centered field="insoleBase" :label="$translate('insoleBaseMat') | capitalize">
              <b-tooltip :label="props.row.insoleBaseTag" position="is-left">
                <img
                  v-if="props.row.insoleBaseImage"
                  :src="props.row.insoleBaseImage"
                  width="75px"
                  height="auto"
                  @click="() => showImageModal(props.row.insoleBaseImage, props.row.insoleBaseTag)"
                />
              </b-tooltip>
            </b-table-column>
            <b-table-column
              width="160px"
              centered
              field="insoleCover"
              :label="$translate('insoleCoverMat') | capitalize"
            >
              <b-tooltip :label="props.row.insoleCoverTag" position="is-left">
                <img
                  v-if="props.row.insoleCoverImage"
                  :src="props.row.insoleCoverImage"
                  width="75px"
                  height="auto"
                  @click="() => showImageModal(props.row.insoleCoverImage, props.row.insoleCoverTag)"
                />
              </b-tooltip>
            </b-table-column>
            <b-table-column width="160px" centered field="insoleFill" :label="$translate('insoleFillMat') | capitalize">
              <b-tooltip :label="props.row.insoleFillTag" position="is-left">
                <img
                  v-if="props.row.insoleFillImage"
                  :src="props.row.insoleFillImage"
                  width="75px"
                  height="auto"
                  @click="() => showImageModal(props.row.insoleFillImage, props.row.insoleFillTag)"
                />
              </b-tooltip>
            </b-table-column>
            <b-table-column :label="$translate('thicknesses') | capitalize" centered>
              <b-button class="is-primary" @click="showThicknessesModal(props.row)">
                <b-icon icon="format-list-checkbox"></b-icon>
              </b-button>
            </b-table-column>
            <b-table-column :label="$translate('Ins_I') | capitalize" centered>
              <b-button class="is-primary" @click="showInsertsModal(props.row)">
                <b-icon icon="format-list-checkbox"></b-icon>
              </b-button>
            </b-table-column>
          </template>
          <b-table-column
            v-if="$moduleConfiguration[module].modelHasCustomSizes && module !== 'insole'"
            centered
            field="customSizes"
            :label="$translate('custom_sizes') | capitalize"
          >
            {{ props.row.sizes.min }} - {{ props.row.sizes.max }}
          </b-table-column>
          <template v-if="$moduleConfiguration[module].soles">
            <b-table-column field="sole" :label="$translate('default_sole') | capitalize">
              <b-tooltip :label="props.row.defaultSoleTag" position="is-left">
                <img :src="props.row.defaultSoleImg" width="75px" height="auto" />
              </b-tooltip>
            </b-table-column>
          </template>
        </template>
      </b-table>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="card">
              <header class="card-header">
                <p class="card-header-title">
                  {{ $translate('filter') | capitalize }}
                </p>
              </header>
              <div class="card-content">
                <filter-select v-model="catalogTypeFilterInfo" @change="searchData()" />
                <filter-select v-model="shoeTypeFilterInfo" @change="searchData()" />
                <filter-select v-model="seasontagsFilterInfo" @change="searchData()" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal :active.sync="isImageModalActive" :width="640" scroll="keep">
        <div class="modal-card" style="width: auto">
          <section class="modal-card-body modal-container">
            <img :src="modalImage" />
          </section>
        </div>
      </b-modal>
      <b-modal :active.sync="isThicknessesModalActive" :width="480" scroll="keep">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $translate('thicknesses') | capitalize }}</p>
          </header>
          <section class="modal-card-body">
            <ul>
              <li v-for="tKey in thicknessKeys" :key="tKey">
                {{ $translate(tKey) | capitalize }}: {{ modalThicknesses[tKey] != null ? modalThicknesses[tKey] : 0 }}
              </li>
            </ul>
          </section>
        </div>
      </b-modal>
      <b-modal :active.sync="isInsertsModalActive" :width="480" scroll="keep">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $translate('Ins_I') | capitalize }}</p>
          </header>
          <section class="modal-card-body">
            <p v-if="!modalInserts.length">-</p>
            <ul v-else>
              <li v-for="(ins, idx) in modalInserts" :key="idx">
                {{ $translate(ins.section) | capitalize }}{{ ins.side ? ` ${ins.side.toUpperCase()}` : '' }}:
                {{ ins.label }} ({{ ins.thickness }} mm)
              </li>
            </ul>
          </section>
        </div>
      </b-modal>
    </div>
  </section>
</template>

<script>
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import filterSelect from '@/components/FilterSelect'
import materialTools from '@/helpers/mixins/materialTools'
export default {
  name: 'Mods',
  components: {
    'filter-select': filterSelect,
  },
  mixins: [permissionMixin, mainMixin, materialTools],
  props: ['catalog', 'catalogmat', 'permissionDenied', 'realmodelcatalog', 'module', 'availablepell', 'availablerip'],
  data() {
    return {
      catalogTypeFilterInfo: {
        label: 'catalogType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      shoeTypeFilterInfo: {
        label: 'shoeType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      seasontagsFilterInfo: {
        label: 'seasontags',
        options: [{ name: '*' }],
        filterValue: '*',
      },

      tableData: [],
      filteredData: [],
      loading: true,
      page: 1,
      total: 0,
      defaultSortOrder: 'desc',
      checkedRows: [],
      queryString: '',

      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,

      tempcatalog: {},

      pells: [],
      accs: [],
      puns: [],
      mors: [],
      sole: [],
      rips: [],
      allacci: [],
      insoleBases: [],
      insoleCovers: [],
      insoleFills: [],
      inserts: [],
      isImageModalActive: false,
      modalImage: '',
      modalTag: '',
      isThicknessesModalActive: false,
      isInsertsModalActive: false,
      modalThicknesses: {},
      modalInserts: [],
      thicknessKeys: ['heel_height', 'ball_height', 'fings_height', 'sup_col_med', 'avvolgenza_mediale'],
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.module]
    },
  },
  watch: {
    tableData: function() {
      this.updateAfterload()
    },
    catalog: {
      handler() {
        this.updateAfterload()
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.loadAsyncData(this.module)
    this.tempcatalog = {}
  },
  methods: {
    showImageModal(img, tag) {
      this.modalImage = img
      this.modalTag = tag
      this.isImageModalActive = true
    },
    showThicknessesModal(row) {
      this.modalThicknesses = row.thicknesses || {}
      this.isThicknessesModalActive = true
    },
    showInsertsModal(row) {
      this.modalInserts = row.insertsList || []
      this.isInsertsModalActive = true
    },
    updateFilters(newshoe) {
      if (this.catalogTypeFilterInfo.options.map(e => e.name).indexOf(newshoe.catalogType) === -1) {
        this.catalogTypeFilterInfo.options.push({
          name: newshoe.catalogType,
        })
      }
      if (this.shoeTypeFilterInfo.options.map(e => e.name).indexOf(newshoe.shoeType) === -1) {
        this.shoeTypeFilterInfo.options.push({
          name: newshoe.shoeType,
        })
      }
      if (this.seasontagsFilterInfo.options.map(e => e.name).indexOf(newshoe.seasontags) === -1) {
        this.seasontagsFilterInfo.options.push({
          name: newshoe.seasontags,
        })
      }
    },
    searchData() {
      this.filteredData = []
      // eslint-disable-next-line no-useless-escape
      let regexp = new RegExp(`\w*${this.queryString}\w*`, `gmi`)
      this.tableData.forEach(shoe => {
        if (
          shoe.name.match(regexp) &&
          (this.catalogTypeFilterInfo.filterValue === '*' ||
            this.catalogTypeFilterInfo.filterValue === shoe.catalogType) &&
          (this.shoeTypeFilterInfo.filterValue === '*' || this.shoeTypeFilterInfo.filterValue === shoe.shoeType) &&
          (this.seasontagsFilterInfo.filterValue === '*' || this.seasontagsFilterInfo.filterValue === shoe.seasontags)
        ) {
          this.filteredData.push(shoe)
        }
      })
    },
    updateAfterload() {
      //debugger
      this.checkedRows = []
      this.tempcatalog = this.catalog
      const ids = Object.keys(this.tempcatalog)
      if (ids.length !== 0 && this.tableData.length > 0) {
        ids.map(id => {
          const model = this.tableData.find(model => model.id === id)
          if (model) {
            this.checkedRows.push(model)
          }
        })
      }
    },
    checkModel(rowchecks) {
      let tempcatalogmat = this.catalogmat
      for (let index in this.tempcatalog) {
        let temprow = rowchecks.find(temp => temp.id === index)
        if (temprow === undefined) {
          delete this.tempcatalog[index]
        }
      }
      for (let index in rowchecks) {
        if (this.tempcatalog[rowchecks[index].id] === undefined || this.tempcatalog[rowchecks[index].id].length === 0) {
          this.tempcatalog[rowchecks[index].id] = true
          this.$buefy.dialog.confirm({
            title: this.$translate('attention'),
            message: this.$translate('confirm_import_model') + ' ' + rowchecks[index].name,
            cancelText: this.$translate('n'),
            onConfirm: () => {
              let model = rowchecks[index]
              const { minPel, maxPel, minRip, maxRip } = this.config
              let pelCounter = minPel !== maxPel ? model.pelCount : maxPel
              for (let i = 1; i <= pelCounter; i++) {
                if (model[`pell${i}var`] != null && model[`pell${i}mat`] != null) {
                  if (
                    tempcatalogmat[this.config.materials.Pel][model[`pell${i}mat`]] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Pel][model[`pell${i}mat`]] = {}
                  }
                  tempcatalogmat[this.config.materials.Pel][model[`pell${i}mat`]][model[`pell${i}var`]] = true
                }
                if (model.possiblePel && model.possiblePel[i]) {
                  const pell = this.availablepell.filter(p => model.possiblePel[i].includes(p.id))
                  for (let mat of pell) {
                    if (
                      tempcatalogmat[this.config.materials.Pel][mat.id] === undefined ||
                      this.tempcatalog[model.id].length === 0
                    ) {
                      tempcatalogmat[this.config.materials.Pel][mat.id] = {}
                    }
                    for (let variant of mat.variants) {
                      tempcatalogmat[this.config.materials.Pel][mat.id][variant.id] = true
                    }
                  }
                }
              }
              if (this.config.modelHasRiporti) {
                let ripCounter = minRip !== maxRip ? model.ripCount : maxRip
                for (let i = 1; i <= ripCounter; i++) {
                  if (model[`rip${i}var`] != null && model[`rip${i}mat`] != null) {
                    if (
                      tempcatalogmat[this.config.materials.Rip][model[`rip${i}mat`]] === undefined ||
                      this.tempcatalog[model.id].length === 0
                    ) {
                      tempcatalogmat[this.config.materials.Rip][model[`rip${i}mat`]] = {}
                    }
                    tempcatalogmat[this.config.materials.Rip][model[`rip${i}mat`]][model[`rip${i}var`]] = true
                  }
                  if (model.possibleRip && model.possibleRip[i]) {
                    const pell = this.availablerip.filter(p => model.possibleRip[i].includes(p.id))
                    for (let mat of pell) {
                      if (
                        tempcatalogmat[this.config.materials.Rip][mat.id] === undefined ||
                        this.tempcatalog[model.id].length === 0
                      ) {
                        tempcatalogmat[this.config.materials.Rip][mat.id] = {}
                      }
                      for (let variant of mat.variants) {
                        tempcatalogmat[this.config.materials.Rip][mat.id][variant.id] = true
                      }
                    }
                  }
                }
              }
              if (this.module === 'fits') {
                if (model.fodmat != null) {
                  model.fodmat.forEach((fodera, i) => {
                    if (fodera.variant != null && fodera.material != null) {
                      if (
                        tempcatalogmat[this.config.materials.Acc][model.fodmat[i].material] === undefined ||
                        this.tempcatalog[model.id].length === 0
                      ) {
                        tempcatalogmat[this.config.materials.Acc][model.fodmat[i].material] = {}
                      }
                      tempcatalogmat[this.config.materials.Acc][model.fodmat[i].material][
                        model.fodmat[i].variant
                      ] = true
                    }
                  })
                }
                if (model.allacci != null) {
                  model.allacci.forEach((allacciatura, i) => {
                    if (
                      tempcatalogmat[this.config.materials.All][model.allacci[i]] === undefined ||
                      this.tempcatalog[model.id].length === 0
                    ) {
                      tempcatalogmat[this.config.materials.All][model.allacci[i]] = {}
                    }
                    tempcatalogmat[this.config.materials.All][model.allacci[i]] = true
                  })
                }
              }
              if (model.bottomColors != null) {
                model.bottomColors.forEach((color, i) => {
                  if (
                    tempcatalogmat[this.config.materials.Col][model.bottomColors[i]] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Col][model.bottomColors[i]] = {}
                  }
                  tempcatalogmat[this.config.materials.Col][model.bottomColors[i]] = true
                })
              }
              if (model.treads != null && model.treads.length > 0) {
                model.treads.forEach((tread, i) => {
                  if (
                    tempcatalogmat[this.config.materials.Pun][model.treads[i]] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Pun][model.treads[i]] = {}
                  }
                  tempcatalogmat[this.config.materials.Pun][model.treads[i]] = true
                })
              }
              if (model.fogge != null && model.fogge.length > 0) {
                model.fogge.forEach((foggia, i) => {
                  if (
                    tempcatalogmat[this.config.materials.Fog][model.fogge[i]] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Fog][model.fogge[i]] = {}
                  }
                  tempcatalogmat[this.config.materials.Fog][model.fogge[i]] = true
                })
              }
              if (this.module === 'tailored') {
                if (model.fodantvar != null && model.fodantmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Acc][model.fodantmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Acc][model.fodantmat] = {}
                  }
                  tempcatalogmat[this.config.materials.Acc][model.fodantmat][model.fodantvar] = true
                }
                if (model.fodposvar != null && model.fodposmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Acc][model.fodposmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Acc][model.fodposmat] = {}
                  }
                  tempcatalogmat[this.config.materials.Acc][model.fodposmat][model.fodposvar] = true
                }
                if (model.battvar != null && model.battmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Pun][model.battmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Pun][model.battmat] = {}
                  }
                  tempcatalogmat[this.config.materials.Pun][model.battmat][model.battvar] = true
                }
                if (model.intevar != null && model.intemat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Mor][model.intemat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Mor][model.intemat] = {}
                  }
                  tempcatalogmat[this.config.materials.Mor][model.intemat][model.intevar] = true
                }
                if (model.tacczeppvar != null && model.tacczepp != null) {
                  if (
                    tempcatalogmat[this.config.materials.Mor][model.tacczepp] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Mor][model.tacczepp] = {}
                  }
                  tempcatalogmat[this.config.materials.Mor][model.tacczepp][model.tacczeppvar] = true
                }

                if (model.guardvar != null && model.guardmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Mat][model.guardmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Mat][model.guardmat] = {}
                  }
                  tempcatalogmat[this.config.materials.Mat][model.guardmat][model.guardvar] = true
                }
                if (model.fascvar != null && model.fascmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Sug][model.fascmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Sug][model.fascmat] = {}
                  }
                  tempcatalogmat[this.config.materials.Sug][model.fascmat][model.fascvar] = true
                }
                if (model.contrvar != null && model.contrmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.PaS][model.contrmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.PaS][model.contrmat] = {}
                  }
                  tempcatalogmat[this.config.materials.PaS][model.contrmat][model.contrvar] = true
                }
                if (model.sottvar != null && model.sottmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Pat][model.sottmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Pat][model.sottmat] = {}
                  }
                  tempcatalogmat[this.config.materials.Pat][model.sottmat][model.sottvar] = true
                }
                if (model.punvar != null && model.punmat != null) {
                  if (
                    tempcatalogmat[this.config.materials.Mez][model.punmat] === undefined ||
                    this.tempcatalog[model.id].length === 0
                  ) {
                    tempcatalogmat[this.config.materials.Mez][model.punmat] = {}
                  }
                  tempcatalogmat[this.config.materials.Mez][model.punmat][model.punvar] = true
                }
              }
              if (this.module === 'insole') {
                const registerInsole = (catKey, mat, variant) => {
                  if (mat == null || variant == null) return
                  if (tempcatalogmat[catKey][mat] === undefined || this.tempcatalog[model.id].length === 0) {
                    tempcatalogmat[catKey][mat] = {}
                  }
                  tempcatalogmat[catKey][mat][variant] = true
                }
                registerInsole(this.config.materials.Moi, model.insoleBaseMat, model.insoleBaseVar)
                registerInsole(this.config.materials.Ric_plan, model.insoleCoverMat, model.insoleCoverVar)
                registerInsole(this.config.materials.Rie_plan, model.insoleFillMat, model.insoleFillVar)
                if (model.inserts) {
                  Object.keys(model.inserts).forEach(section => {
                    model.inserts[section].forEach(slot => {
                      registerInsole(this.config.materials.Ins, slot.material, slot.variant)
                    })
                  })
                }
              }
              this.$emit('update:catalogmat', tempcatalogmat)
              this.$emit('updateMaterials')
            },
            confirmText: this.$translate('y'),
            onCancel: () => {
              this.checkedRows.splice(index, 1)
            },
          })
        }
      }
      this.$emit('update:catalog', this.tempcatalog)
    },
    arrichData(doc) {
      let newmod = doc.data()
      newmod.id = doc.id
      let tempmat, tempvar
      let pelCount = 0
      let ripCount = 0
      for (let i = 1; i <= this.config.maxPel; i++) {
        let tempmat = this.pells.find(temp => temp.id === newmod[`pell${i}mat`])
        let tempvar = {}
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id == newmod[`pell${i}var`])
          if (tempvar !== undefined) {
            newmod[`pellImage${i}`] = tempvar.image
            newmod[`pell${i}tag`] = this.$translateMaterial(tempmat) + '-' + tempvar.name
            if (i > pelCount) pelCount = i
          }
        }
      }
      newmod.pelCount = pelCount

      for (let i = 0; i <= this.config.maxRip; i++) {
        let tempmat = this.rips.find(temp => temp.id === newmod[`rip${i}mat`])
        let tempvar = {}
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod[`rip${i}var`])
          if (tempvar !== undefined) {
            newmod[`ripImage${i}`] = tempvar.image
            newmod[`rip${i}tag`] = this.$translateMaterial(tempmat) + '-' + tempvar.name
            if (i > ripCount) ripCount = i
          }
        }
      }
      newmod.ripCount = ripCount

      if (this.module === 'fits') {
        newmod.fodmat.forEach(fodera => {
          tempmat = this.accs.find(temp => temp.id === fodera.material)
          if (tempmat !== undefined) {
            tempvar = tempmat.variants.find(temp => temp.id === fodera.variant)
            if (tempvar !== undefined) {
              newmod.accTags.push(this.$translateMaterial(tempmat) + '-' + tempvar.name)
            }
          }
        })
        newmod.allacci.forEach(allacciatura => {
          tempmat = this.allacci.find(temp => temp.id === allacciatura)
          if (tempmat !== undefined) {
            newmod.allTags.push(this.$translateMaterial(tempmat))
          }
        })
      }

      if (this.config.soles) {
        tempmat = this.soles.find(temp => temp.id === newmod.sole_default)
        if (tempmat !== undefined) {
          newmod.defaultSoleImg = tempmat.image
          newmod.defaultSoleTag = this.$translateMaterial(tempmat)
        }
      }

      if (this.module === 'tailored') {
        tempmat = this.accs.find(temp => temp.id === newmod.fodantmat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.fodantvar)
          if (tempvar !== undefined) {
            newmod.fodImage1 = tempvar.image
            newmod.fod1tag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
        tempmat = this.accs.find(temp => temp.id === newmod.fodposmat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.fodposvar)
          if (tempvar !== undefined) {
            newmod.fodImage2 = tempvar.image
            newmod.fod2tag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }

        tempmat = this.puns.find(temp => temp.id === newmod.battmat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.battvar)
          if (tempvar !== undefined) {
            newmod.batImage = tempvar.image
            newmod.battag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }

        tempmat = this.mors.find(temp => temp.id === newmod.intemat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.intevar)
          if (tempvar !== undefined) {
            newmod.intImage = tempvar.image
            newmod.inttag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
      }

      if (this.module === 'insole') {
        tempmat = this.insoleBases.find(temp => temp.id === newmod.insoleBaseMat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.insoleBaseVar)
          if (tempvar !== undefined) {
            newmod.insoleBaseImage = tempvar.image
            newmod.insoleBaseTag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
        tempmat = this.insoleCovers.find(temp => temp.id === newmod.insoleCoverMat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.insoleCoverVar)
          if (tempvar !== undefined) {
            newmod.insoleCoverImage = tempvar.image
            newmod.insoleCoverTag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
        tempmat = this.insoleFills.find(temp => temp.id === newmod.insoleFillMat)
        if (tempmat !== undefined) {
          tempvar = tempmat.variants.find(temp => temp.id === newmod.insoleFillVar)
          if (tempvar !== undefined) {
            newmod.insoleFillImage = tempvar.image
            newmod.insoleFillTag = this.$translateMaterial(tempmat) + '-' + tempvar.name
          }
        }
        newmod.insertsList = []
        if (newmod.inserts) {
          Object.keys(newmod.inserts)
            .sort()
            .forEach(key => {
              if (!Array.isArray(newmod.inserts[key])) return
              const side = key.endsWith('_sx') ? 'sx' : key.endsWith('_dx') ? 'dx' : ''
              const section = side ? key.slice(0, -3) : key
              newmod.inserts[key].forEach(slot => {
                if (slot.material == null || slot.variant == null) return
                const insertMat = this.inserts.find(temp => temp.id === slot.material)
                if (insertMat !== undefined) {
                  const insertVar = insertMat.variants.find(temp => temp.id === slot.variant)
                  if (insertVar !== undefined) {
                    newmod.insertsList.push({
                      section,
                      side,
                      label: this.$translateMaterial(insertMat) + '-' + insertVar.name,
                      thickness: slot.thickness,
                    })
                  }
                }
              })
            })
        }
      }
      return newmod
    },

    async loadAsyncData(module) {
      this.tableOptions.loading = true
      this.createFilters()
      this.tableData = []
      switch (module) {
        case 'tailored':
          await this.loadAsyncDataTailored()
          break
        case 'fits':
          await this.loadAsyncDataFits()
          break
        case 'modular':
          await this.loadAsyncDataModular()
          break
        case 'insole':
          await this.loadAsyncDataInsole()
          break
      }
    },

    loadAsyncDataInsole() {
      this.loading = true
      const materialsText = ['Moi_I', 'Ric_plan_I', 'Rie_plan_I', 'Ins_I']
      this.getMaterialsArray(materialsText).then(arraysresponse => {
        this.insoleBases = arraysresponse[0]
        this.insoleCovers = arraysresponse[1]
        this.insoleFills = arraysresponse[2]
        this.inserts = arraysresponse[3]
        this.tableData = []
        const tempData = []
        this.$db
          .collection(this.config.models)
          .where('draft', '==', false)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              let newmod = this.arrichData(doc)
              tempData.push(newmod)
              this.realmodelcatalog.push(newmod)
              this.filteredData.push(newmod)
              this.updateFilters(newmod)
            })
            this.loading = false
            this.tableData = tempData
          })
      })
    },

    loadAsyncDataTailored() {
      this.loading = true
      const materialText = ['Pel', 'Acc', 'Pun', 'Mor']
      this.getMaterialsArray(materialText).then(arraysresponse => {
        this.pells = arraysresponse[0]
        this.accs = arraysresponse[1]
        this.puns = arraysresponse[2]
        this.mors = arraysresponse[3]
        this.tableData = []
        this.$db
          .collection(this.config.models)
          .where('draft', '==', false)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              let newmod = this.arrichData(doc)
              this.tableData.push(newmod)
              this.realmodelcatalog.push(newmod)
              this.filteredData.push(newmod)
              this.updateFilters(newmod)
            })
            this.loading = false
          })
      })
    },
    loadAsyncDataFits() {
      this.loading = true
      const materialText = ['Pel_F', 'soles']
      this.getMaterialsArray(materialText).then(arraysresponse => {
        this.pells = arraysresponse[0]
        this.soles = arraysresponse[1]
        this.tableData = []
        this.$db
          .collection(this.config.models)
          .where('draft', '==', false)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              let newmod = this.arrichData(doc)
              this.tableData.push(newmod)
              this.realmodelcatalog.push(newmod)
              this.filteredData.push(newmod)
              this.updateFilters(newmod)
            })
            this.loading = false
          })
      })
    },
    async loadAsyncDataModular() {
      this.loading = true
      const materialsText = ['Pel_M', 'Rip_M', 'soles_M']
      this.getMaterialsArray(materialsText).then(arraysresponse => {
        this.pells = arraysresponse[0]
        this.rips = arraysresponse[1]
        this.soles = arraysresponse[2]
        this.tableData = []
        const tempData = []
        this.$db
          .collection(this.config.models)
          .where('draft', '==', false)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              let newmod = this.arrichData(doc)
              tempData.push(newmod)
              this.realmodelcatalog.push(newmod)
              this.filteredData.push(newmod)
              this.updateFilters(newmod)
            })
            this.loading = false
            this.tableData = tempData
          })
      })
    },
    createFilters() {
      this.catalogTypeFilterInfo.options = [{ name: '*' }]
      this.shoeTypeFilterInfo.options = [{ name: '*' }]
      this.seasontagsFilterInfo.options = [{ name: '*' }]
      this.tableData.forEach(shoe => {
        if (this.catalogTypeFilterInfo.options.map(e => e.name).indexOf(shoe.catalogType) === -1) {
          this.catalogTypeFilterInfo.options.push({
            name: shoe.catalogType,
          })
        }
        if (this.shoeTypeFilterInfo.options.map(e => e.name).indexOf(shoe.shoeType) === -1) {
          this.shoeTypeFilterInfo.options.push({
            name: shoe.shoeType,
          })
        }
        if (this.seasontagsFilterInfo.options.map(e => e.name).indexOf(shoe.seasontags) === -1) {
          this.seasontagsFilterInfo.options.push({
            name: shoe.seasontags,
          })
        }
      })
    },
    /*checkMaterialList(tempcatalogmat, model, dbKey, materialKey, variantKey) {
      if (model[variantKey] != null) {
        if (!tempcatalogmat[materialKey]) {
          tempcatalogmat[materialKey] = {}
        }
        if (!tempcatalogmat[materialKey][model[materialKey]]) {
          tempcatalogmat[materialKey][model[materialKey]] = {}
        }
        tempcatalogmat[materialKey][model[materialKey]][model[variantKey]] = true
      }
    },*/
  },
}
</script>
<style scoped>
.container >>> select {
  width: 200px;
}
.pellami-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.modal-container {
  display: flex;
  justify-content: center;
}
</style>
